interface CaseInfoPanelProps {
  projectName?: string | null
  caseName?: string | null
  studyDate?: string | null
}

function displayValue(value?: string | null): string {
  if (!value) return "—"
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : "—"
}

export function CaseInfoPanel({ projectName, caseName, studyDate }: CaseInfoPanelProps) {
  return (
    <section className="border-b border-border shrink-0">
      <div className="px-2.5 py-2 text-[10px] font-medium text-muted-foreground uppercase tracking-wide border-b border-border">
        Case Info
      </div>
      <dl className="px-2.5 py-2 space-y-1.5">
        <div className="grid grid-cols-[72px_1fr] gap-2 items-center">
          <dt className="text-[10px] text-muted-foreground uppercase tracking-wide">Project</dt>
          <dd className="text-[11px] font-medium truncate">{displayValue(projectName)}</dd>
        </div>
        <div className="grid grid-cols-[72px_1fr] gap-2 items-center">
          <dt className="text-[10px] text-muted-foreground uppercase tracking-wide">Case</dt>
          <dd className="text-[11px] font-medium truncate">{displayValue(caseName)}</dd>
        </div>
        <div className="grid grid-cols-[72px_1fr] gap-2 items-center">
          <dt className="text-[10px] text-muted-foreground uppercase tracking-wide">Study Date</dt>
          <dd className="text-[11px] font-medium truncate">{displayValue(studyDate)}</dd>
        </div>
      </dl>
    </section>
  )
}
